import React, { useEffect, useState } from "react";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { deleteDasteProfile } from "Stores/actions";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import Translator from "Languages/Utility/Translator";
import * as Icons from 'react-bootstrap-icons';

function DeleteDasteProfile({reGetOnBack}) {
  const { dataRelationDasteProfile, selectedDasteProfile } = useSelector((state) => ({
    dataRelationDasteProfile: state.profile.dataRelationDasteProfile,
    selectedDasteProfile: state.profile.selectedDasteProfile,
  }));
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: selectedDasteProfile.Id,
      };
      const res = await dispatch(deleteDasteProfile(data));
      reGetOnBack(true);
      if (res) {
        onShowAlert();
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationDasteProfile);
  }, [dataRelationDasteProfile]);

  return (
    <>
      <MuiIconButton
        title={<Translator id={"delete"}/>}
        icon={<Icons.Trash3 size={17} />}
        onClick={onShowAlert}
        className="danger-fill"
        disabled={selectedDasteProfile.Disable ||
        (selectedDasteProfile.IsG && read("StypeU") !== "1") ||
        (read("addSeriProfileRules").accessDelete === false && read("StypeU") !== "1")
        }
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id={"ble_pak_shavad"}/>}
        cancelTitle={<Translator id={"enseraf"}/>}
        questionText={<Translator id={"aya_az_hazf_an_etminan_darid"}/>}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteDasteProfile;
